import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { SET_ACTIVE_TAB } from "../../redux/actions/main";
import ReleasesTable from "./fragments/Table";
import useReleases from '../../hooks/useReleases'; // Importamos el hook

const ReleasesClient = () => {
    const login = useSelector(state => state.login);
    const role_selected = login.role_selected;
    const headers = { Authorization: `Bearer ${login.token}` };
    const fibra_id = login.fibra.id;

    const [t] = useTranslation('global');
    const prefix = 'releases.data';
    const dispatch = useDispatch();

    // Usamos el hook para obtener los comunicados filtrados por el role_selected
    const hookReleases = useReleases({ headers, fibra_id, role_id: role_selected.id, user_id: null, active: null });

    // Establecemos la pestaña activa una vez que el componente se monte
    useEffect(() => {
        dispatch({ type: SET_ACTIVE_TAB, tab: '/releases/client' });
    }, [dispatch]);

    return (
        <ReleasesTable
            theaders={[
                '#',
                t(`${prefix}.title`),
                t(`${prefix}.status`),
                t(`${prefix}.created_at`),
                t(`${prefix}.actions`),
            ]}
            tkeys={['#', 'title', 'status', 'created_at']}
            tbadges={[]}
            hookReleases={hookReleases}
            moment_dates={[{ index: 3, format: 'LLLL' }]}
        />
    );
};

export default ReleasesClient;

